







































































import { Component, Vue, Prop } from "vue-property-decorator";
import { namespace } from "vuex-class";

/**
 * Utils
 */
import classes from "@/config/wow/classes";
import * as externalLinks from "@/config/external-links";
import * as imageLinks from "@/config/image-links";
import armorTypes from "@/config/wow/armor-types";

import { colorPlayerCount } from "./lib/helpers";

import { getElegantDateString, getLocaleStringFromDateString } from "@/utils/date-helpers";
import { sortByAsc } from "@/utils/sort-helpers";

/**
 * Components
 */
import GroupCard from "@/components/_global/GroupCard.vue";

/**
 * API
 */
import { CompositionGroupResponse, GetOneCompositionGroupResponse } from "@/api/compositions/get-one-composition-group.response";
import { GetOneTeamResponse } from "@/api/teams/get-one-team.response";
import { Guid } from "@/domain/guid";
import DataFetcher from "@/components/_global/DataFetcher.vue";
import { thumbnailClass } from "@/config/image-links";


/**
 * Types
 */

/**
 * VueX Modules
 */
const teamModule = namespace("team");

/**
 * Compositions' view distribution page.
 */
@Component({
	methods: {thumbnailClass},
	components: {
		DataFetcher,
		GroupCard
	}
})
export default class CompositionsViewDistributionPage extends Vue {
	/// Injections
	classes = classes;
	externalLinks = externalLinks;
	imageLinks = imageLinks;
	armorTypes = armorTypes;
	colorPlayerCount = colorPlayerCount;
	getElegantDateString = getElegantDateString;
	getLocaleStringFromDateString = getLocaleStringFromDateString;

	/// Props
	@Prop()
	compositionGroup!: GetOneCompositionGroupResponse | null;
	@Prop()
	notifyFetchCompositionGroup!: () => Promise<void>;

	/// Attributes
	isLoading = false;

	/// VueX Modules
	@teamModule.State("team")
	currentTeam!: GetOneTeamResponse;

	get headers() {
		return [
			{
				text: this.$t("composition.character"),
				value: "character",
				align: "left",
				class: "collapsing",
				sort: sortByAsc(x => x != null && x.name),
				sortable: false
			},
			...this.compositionGroup != null ? this.compositionGroup.compositions
				.filter(composition => composition.characters.length > 0)
				.map(composition =>
					({
						text: composition.name,
						value: composition.id,
						align: "center",
						class: "collapsing",
						sortable: false
					})
				) : [],
			{
				text: this.$t("composition.total"),
				value: "total",
				align: "left",
				class: "collapsing",
				sortable: false
			},
		];
	}

	get usedCharacters() {
		if (this.compositionGroup == null) {
			return [];
		}

		return this.compositionGroup.compositions.reduce((arr: CompositionGroupResponse.Character[], composition) => {
			const charactersNotYetInArr = composition.characters.filter(c => !arr.some(ac => ac.id === c.id));
			return [...arr, ...charactersNotYetInArr];
		}, []);
	}

	get displayedData() {
		const compositionGroup = this.compositionGroup;

		if (compositionGroup == null) {
			return [];
		}

		if (this.usedCharacters.length == 0) {
			return [];
		}

		return [
			...this.usedCharacters.map(character => {
				const res: any = {};
				res.compositions = {};
				for (const composition of compositionGroup.compositions) {
					res.compositions[composition.id] = composition.characters.find(c => c.id === character.id);
				}
				res.name = character.name;
				res.total = Object.keys(res.compositions).reduce((sum: number, k) => sum + (res.compositions[k] != null ? 1 : 0), 0);
				res.character = character;
				return res;
			}),
			{
				name: "",
				character: null,
				total: null
			}
		];
	}

	/// Methods
	async created() {
	}

	async fetch() {
		await this.fetchCompositionGroup();
	}

	async fetchCompositionGroup() {
		await this.notifyFetchCompositionGroup();
	}

	getSlotName(compositionID: Guid) {
		return `item.${compositionID}`;
	}

	getHeaderSlotName(compositionID: Guid) {
		return `header.${compositionID}`;
	}
}
